import EventEmitter from './EventEmitter';

export default class Loading extends EventEmitter {
    progress = 0;
    started = false;
    finished = false;

    setProgress(loaded: number, total: number) {
        if (!this.started) {
            this.started = true;
            this.trigger('start');
        }
        this.progress = total > 0 ? loaded / total : 0;
        this.trigger('progress', [this.progress]);
        if (loaded >= total && !this.finished) {
            this.finished = true;
            this.trigger('ready');
        }
    }
}
